window.$ = window.jQuery = require('jquery');
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';

// Get the current URL
let currentURL = new URL(window.location.href);
// Get the path segments
let pathSegments = currentURL.pathname.split('/');

jQuery(function () {

   function agendaGridListSlider() {
      $('.agenda-26-grid-pagebuilder').not('.slick-initialized').slick({
         slidesToShow: 3.5,
         slidesToScroll: 1,
         autoplay: false,
         infinite: false,
         arrows: true,
         dots: false,
         prevArrow:
           "<button type='button' id='prev-btn' class='slick-prev pull-left'><img src='https://vepimg.b8cdn.com/uploads/vjfnew//content/files/1724155881arrow-left-svg1724155881.svg'></button>",
         nextArrow:
           "<button type='button' id='nxt-btn' class='slick-next pull-right'><img src='https://vepimg.b8cdn.com/uploads/vjfnew//content/files/1724155881arrow-right-svg1724155881.svg'></button>",

         responsive: [
            {
               breakpoint: 1024,
               settings: {
                  slidesToShow: 2.5,
                  slidesToScroll: 1
               }
            },
            {
               breakpoint: 749,
               settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
               }
            }
         ]
      })
      $('.agenda-26-speakers').each(function () {
         var speakerCount = $(this).find('.agenda-26-sp-info').length;
         console.log(speakerCount);
         if (speakerCount <= 1) {
            $(this).find('.agenda-26-sp-more').remove();
         }
      })

      $('.agenda-26-speakers .agenda-26-sp-info:not(:first-child)').addClass('more hide-element');
      $(document).off('click', '.agenda-26-info-modal').on("click", '.agenda-26-info-modal',function(){
         $(this).fadeOut();
      })

      $(document).off('click', '.button.btn-close').on("click", '.button.btn-close',function(){
         $(this).parents('.agenda-26-info-modal').fadeOut();
      })

      if (pathSegments.length < 2 || pathSegments[1] !== 'backend') {
         $('.agenda-26-grid-landingpage').not('.slick-initialized').slick({
            slidesToShow: 3.5,
            slidesToScroll: 1,
            autoplay: false,
            infinite: false,
            arrows: true,
            dots: false,
            prevArrow:
              "<button type='button' id='prev-btn' class='slick-prev pull-left'><img src='https://vepimg.b8cdn.com/uploads/vjfnew//content/files/1724155881arrow-left-svg1724155881.svg'></button>",
            nextArrow:
              "<button type='button' id='nxt-btn' class='slick-next pull-right'><img src='https://vepimg.b8cdn.com/uploads/vjfnew//content/files/1724155881arrow-right-svg1724155881.svg'></button>",

            responsive: [
               {
                  breakpoint: 1024,
                  settings: {
                     slidesToShow: 2.5,
                     slidesToScroll: 1
                  }
               },
               {
                  breakpoint: 749,
                  settings: {
                     slidesToShow: 1,
                     slidesToScroll: 1
                  }
               }
            ]
         })
         // Agenda 26 grid/list script
         $(document).off('click', '.agenda-26-filter-toggle').on('click', '.agenda-26-filter-toggle',function(){
            $(this).siblings('.agenda-26-filter-tabs').slideToggle();
         })
         $(document).off('click', '.agenda-26-layouts-btn').on('click', '.agenda-26-layouts-btn',function(){
            $('.agenda-26-cols').toggleClass('agenda-26-grid agenda-26-list');
         })
         $(document).off('click', '.agenda-26-speakers .agenda-26-sp-more').on('click', '.agenda-26-speakers .agenda-26-sp-more',function(){
            if ($(this).hasClass('visible')) {
               $(this).parent().find('.more').next('.agenda-26-sp-bio').slideUp();
               $(this).parent().find('.more').addClass('hide-element')
               $(this).removeClass('visible')
               $(this).text('+')
            } else {
               $(this).parent().find('.more').removeClass('hide-element')
               $(this).addClass('visible')
               $(this).text('-')
            }
         })
         $(document).off('click', '.agenda-26-sp-info').on('click', '.agenda-26-sp-info',function(){
            $(this).next('.agenda-26-sp-bio').slideToggle();
         })
         $(document).off('click', '.agenda-26-view-info').on("click", '.agenda-26-view-info',function(){
            var sessionTitlePopup = $(this).siblings('h3').text();
            var sessionSubjectPopup = $(this).siblings('.agenda-26-session-info').html();
            $(this).closest('#agenda-style-26').find('.agenda-26-info-modal').find('.age-des-title').text(sessionTitlePopup);
            $(this).closest('#agenda-style-26').find('.agenda-26-info-modal').find('.age-des-body').html(sessionSubjectPopup);
            $(this).closest('#agenda-style-26').find('.agenda-26-info-modal').fadeIn();
         })
         $(document).off('click', '#filter-checkbox input').on("click", '#filter-checkbox input',function(){
            var thisELEM = $(this);
            var thisGroupID = thisELEM.val();

            if (thisELEM.is(':checked')) {
               $(".agenda-26-col[group-num-attribute='" + thisGroupID + "']").closest('.slick-slide').show();
            } else {
               $(".agenda-26-col[group-num-attribute='" + thisGroupID + "']").closest('.slick-slide').hide();
            }
            var checkedCount = $('.agenda-26-filter-tabs input[type="checkbox"]:checked').length;
            if (parseInt(checkedCount) < 4) {
            //$("#prev-btn").hide();
               $('#nxt-btn').hide();
            } else {
               $('#nxt-btn').show();
               //$("#prev-btn").show();
            }
         })
      }
   }

   window.addEventListener('initSpeakerGridListSlider', function(event) {
      speakerGridListSlider();
   });

   function speakerGridListSlider(){
      $('.speakers-layout-slider').not('.slick-initialized').slick({
         slidesToShow: 4,
         slidesToScroll: 1,
         autoplay: false,
         infinite: true,
         arrows: true,
         dots: false,
         responsive: [
            {
               breakpoint: 1024,
               settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
               }
            },
            {
               breakpoint: 767,
               settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
               }
            },
            {
               breakpoint: 576,
               settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
               }
            }
         ]
      });

      $(document).off('click', '.open-sp-bio').on("click", '.open-sp-bio',function(){
         $('.sp-des-modal').fadeIn();
         var spName = $(this).closest('.open-sp-bio-wraper').find('.sp-name').html();
         var spDesignation = $(this).closest('.open-sp-bio-wraper').find('.sp-emp-name').html();
         var spInfo = $(this).closest('.open-sp-bio-wraper').find('.sp-bio-description').html();
         var spImg = $(this).closest('.open-sp-bio-wraper').find('.sp-img').attr('src');
         $('.sp-des-modal').find('.sp-des-img').attr("src", spImg);
         $('.sp-des-modal').find('.sp-des-title').html(spName);
         $('.sp-des-modal').find('.sp-des-description').html(spDesignation);
         $('.sp-des-modal').find('.sp-des-info').html(spInfo);
      });

      $(document).off('click', '.sp-des-modal button.btn-close').on("click", '.sp-des-modal button.btn-close',function(){
         $(this).parents('.sp-des-modal').fadeOut();
      });

      $(document).off('click', '.sp-des-modal button.close-btn').on("click", '.sp-des-modal button.close-btn',function(){
         $(this).parents('.sp-des-modal').fadeOut();
      });
   }

   $(document).ready(function(){
      // Agenda 26 grid/list caroucel
      agendaGridListSlider();
      speakerGridListSlider();
      $('.agenda-tabs .nav-item:first-child .nav-link').addClass('active');
      $('.agenda-content .agenda-container:first-child').removeClass('hide-agenda');
      $('.agenda-content .agenda-parent-container:first-child').removeClass('hide-agenda');
      $('.agenda-tabs .nav-item .nav-link').click(function(){
         $(this).parent('.nav-item').siblings('.nav-item').find('.nav-link').removeClass('active');
         $(this).addClass('active');
         var agendaclickid = $(this).attr('id');
         $(this).parents('.agenda-tabs').siblings('.agenda-content').find('.agenda-container').addClass('hide-agenda');
         $(this).parents('.agenda-tabs').siblings('.agenda-content').find('.agenda-parent-container').addClass('hide-agenda');
         $(this).parents('.agenda-tabs').siblings('.agenda-content').find('#'+agendaclickid).removeClass('hide-agenda').find('.agenda-tabs .nav-item:first-child .nav-link').trigger('click');;
      })

      $(document).off('click', '.modal-target').on("click", '.modal-target',function(){
         $(this).siblings('.custom-info-modal').fadeIn();
      })
      $(document).off('click', '.custom-info-modal').on("click", '.custom-info-modal',function(){
         $(this).fadeOut();
      })
      $(document).off('click', '.modal-target button.btn-close').on("click", '.modal-target button.btn-close',function(){
         $(this).parents('.custom-info-modal').fadeOut();
      })

      $(document).off('click', '.view-hide-abstract').on('click', '.view-hide-abstract', function(){
         var sessionDetail = $(this).siblings('.session-detail');

         if (sessionDetail.css('display') === 'none') {
            sessionDetail.css('display', 'block');
         } else {
            sessionDetail.css('display', 'none');
         }
         $(this).hide();
         $(this).siblings('.view-hide-abstract').show();
      })

      $('#agenda-style-new-1 .agenda-info .agenda-title, #agenda-style-backend-26 .agenda-info .agenda-title').off('click').on('click', function(){
         if ($(this).parent('.agenda-info').hasClass('agenda-info-close')) {
            $(this).parent('.agenda-info').removeClass('agenda-info-close');
            $(this).parent('.agenda-info').addClass('agenda-info-open');
            $(this).parent('.agenda-info').find('.age-des-body-short-description').hide();
            $(this).parent('.agenda-info').find('.age-des-body-ling-description').show();
         } else {
            $(this).parent('.agenda-info').removeClass('agenda-info-open');
            $(this).parent('.agenda-info').addClass('agenda-info-close');
            $(this).parent('.agenda-info').find('.age-des-body-ling-description').hide();
            $(this).parent('.agenda-info').find('.age-des-body-short-description').show();
         }
      })

      $('#agenda-style-backend-2 .agenda-group:first-child .agenda-rows:nth-child(2) .agenda-session-title i, ' +
     '#agenda-style-backend-3 .agenda-group:first-child .agenda-rows:nth-child(2) .agenda-session-title i, ' +
     '#agenda-style-backend-5 .agenda-group:first-child .agenda-rows:nth-child(2) .agenda-session-title i , ' +
     '#agenda-style-backend-21 .agenda-group:first-child .agenda-rows:nth-child(2) .agenda-session-title i, ' +
     '#agenda-style-backend-22 .agenda-group:first-child .agenda-rows:nth-child(2) .agenda-session-title i')
     .removeClass('fa-angle-down')
     .addClass('fa-angle-up');
      $('.agenda-session-title').off('click').on('click', function(){
         var sessionDetail = $(this).next('.session-detail-backend-agenda');
         if (sessionDetail.css('display') === 'none') {
            sessionDetail.css('display', 'block');
            sessionDetail.siblings('.agenda-session-title').find('i').removeClass('fa-angle-down');
            sessionDetail.siblings('.agenda-session-title').find('i').addClass('fa-angle-up');
         } else {
            sessionDetail.css('display', 'none');
            sessionDetail.siblings('.agenda-session-title').find('i').removeClass('fa-angle-up');
            sessionDetail.siblings('.agenda-session-title').find('i').addClass('fa-angle-down');
         }
      });
   })

   if (pathSegments.length < 2 || pathSegments[1] !== 'backend') {
      //Agenda Tabs Fix
      $('.agenda-sec .card:first-child .card-header').removeClass('openagendacard');
      $('.agenda-sec .card:first-child .card-header').addClass('closeagendacard');
      $('.agenda-sec .card:first-child .agendacollapse').removeClass('hide-agenda');
      
      // First unbind any existing click handlers
      $(document).off('click', '.agenda-sec .card .card-header .btn');
      // Then bind the new click handler
      $(document).on('click', '.agenda-sec .card .card-header .btn', function(){
         $(this).parents('.card').siblings('.card').find('.card-header').removeClass('closeagendacard');
         $(this).parents('.card').siblings('.card').find('.card-header').addClass('openagendacard');
         $(this).parent('.card-header').toggleClass('openagendacard closeagendacard');
         $(this).parents('.card').siblings('.card').find('.agendacollapse').addClass('hide-agenda');
         $(this).parent('.card-header').siblings('.agendacollapse').toggleClass('hide-agenda');

         // Instant scroll without animation
         window.scrollTo(0, $(this).offset().top - 100);
      });

      //Agenda Layout 5 JS
      // First unbind existing click handler
      $(document).off('click', '.show-ag-detail');
      // Then bind the new click handler
      $(document).on('click', '.show-ag-detail', function() {
         $(this).toggleClass('active');
         $(this).next('.agenda-description').toggleClass('active');
      });
      //Agenda Layout 5 JS Ends Here
   }
 })

